import styled from 'styled-components';
import {tokens} from "../../theme";

export const PageSizeContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const PageSizeButton = styled.button<{ $isSelected: boolean }>`
    padding: 6px;
    min-width: 30px;
    height: 30px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;

    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${tokens.fontSize.base};
    font-weight: ${props => props.$isSelected ? 'bold' : 'normal'};
    
    color: ${({$isSelected, theme}) => $isSelected 
            ? theme.palette.action.primary
            : theme.palette.text.secondary
    };
    
    background-color: ${({$isSelected, theme}) => $isSelected
            ? theme.palette.action.selectedBackground 
            : 'transparent'};
    
    border-radius: ${tokens.radius.lg};
    transition: background-color 0.2s ease, color 0.2s ease;

    &:hover {
        background-color: ${({$isSelected, theme}) => $isSelected
                ? theme.palette.action.hoveredBackground
                : theme.palette.action.hoveredBackground
    };
`;
